import { Injectable } from '@angular/core';
import { PlessHttp } from 'src/app/shared/http/pless-http.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonUploadServiceSub } from 'src/app/commons/kymw00/pless-json-upload-sub.service';
import { PlessDialogServiceSub } from 'src/app/commons/kymw00/pless-dialog-service-sub';
import { KYMW1100Model } from '../kymw1100.model';

import type { EBaseImportGoodsInfo } from '../vo/update-ebase-data-request.model';

// リクエスト構造
export interface UpdateEBaseDataRequest {
  update: {
    EbaseListGoodsInfo: {
      combination: {
        parameter: EBaseImportGoodsInfo
      }[];
    };
  };
}

// レスポンス構造
export interface UpdateEBaseDataResponse {
  /** 正常件数 */
  NormalNum: number;
  /** 注意件数 */
  AttentionNum: number;
  /** 以上件数 */
  AbnormalNum: number;
  /** DB更新件数 */
  UpdateNum: number;
  /** 処理件数 */
  ManageNum: number;
}

/** eBASE 取込商品候補一覧取得 サービス */
@Injectable({
  providedIn: 'root'
})
export class UpdateEBaseDataService extends PlessJsonUploadServiceSub<UpdateEBaseDataResponse> {
  model: KYMW1100Model;
  private requestData: UpdateEBaseDataRequest;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @returns {PlessRequest} リクエストJSON
   */
  private getBody(eBaseImportGoodsList: EBaseImportGoodsInfo[]): PlessRequest {
    const combination = eBaseImportGoodsList.map(importData => ({parameter: importData}));

    this.requestData = {
      update: {
        EbaseListGoodsInfo: {
          combination,
        }
      }
    };

    return new PlessRequest(this.requestData);
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param eBaseImportGoodsList リクエスト用データ (リスト)
   * @memberof GetEbaseCandidateListService
   */
  execute(model: KYMW1100Model, eBaseImportGoodsList: EBaseImportGoodsInfo[], file: File, successFunc: Function = null): void {
    this.model = model;
    this.successFunc = successFunc;
    this.sendFile('updateEBaseData', this.getBody(eBaseImportGoodsList), file);
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetEbaseCandidateListService
   */
  success(data: UpdateEBaseDataResponse) {
    this.model.setEbaseDataKYMW0D00(data);
    if (this.successFunc) {
      this.successFunc(data);
    }
  }

}
